import { styled } from 'styled-components'
import { Drawer as CssModulesDrawer } from '../Drawer'
import { Item as CssModulesItem } from '../Item'
import { Items as CssModulesItems } from '../Items'

/**
 * @description
 * Styled-components wrapper for the CSS Modules Drawer component.
 * Maps transient prop $isDisabled to the isDisabled prop.
 */
export const Drawer = styled(CssModulesDrawer)``
export const Items = styled(CssModulesItems)``
export const Item = styled(CssModulesItem)``
